export default __webpack_public_path__ + "static/media/015-flask.267ec8cb.svg";